import React from "react";
import { Table, Tag } from "antd";
import dayjs from "dayjs";
import { Product } from "../../../Types";

interface StockTableProps {
  record: Product;
}

export const StockTable: React.FC<StockTableProps> = ({ record }) => {
  const stockBatchColumns = [
    {
      title: "Batch No",
      dataIndex: "batch_no",
      key: "batch_no",
      render: (v: string, rec: any) => (
        <div className="flex items-center gap-2">
          <span className="font-semibold text-gray-600">{v}</span>
        </div>
      ),
    },
    {
      title: "Cost Price",
      dataIndex: "cost_price",
      key: "cost_price",
      render: (v: number) => (
        <span className="text-red-500 font-medium">Rs. {v.toFixed(2)}</span>
      ),
    },
    {
      title: "Retail Price",
      dataIndex: "retail_price",
      key: "retail_price",
      render: (v: number) => (
        <span className="text-green-600 font-medium">Rs. {v.toFixed(2)}</span>
      ),
    },
    {
      title: "Wholesale Price",
      dataIndex: "wholesale_price",
      key: "wholesale_price",
      render: (v: number) => (
        <span className="text-blue-600 font-medium">Rs. {v.toFixed(2)}</span>
      ),
    },
    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      key: "expiry_date",
      render: (v: string) => (
        <span className="text-gray-600 font-medium">
          {v ? dayjs(v).format("YYYY-MM-DD") : "No Expiry"}
        </span>
      ),
    },
    {
      title: "Stock Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (v: number) => (
        <Tag
          color={v <= 0 ? "error" : v < 10 ? "warning" : "success"}
          className="font-medium"
        >
          {v}
        </Tag>
      ),
    },
  ];

  return (
    <div className="px-6 py-4 bg-gray-50 border-y border-gray-200">
      <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm flex flex-col">
        <div className="mb-3 flex items-center justify-between">
          <span className="text-xs font-bold text-gray-500 uppercase tracking-wider">
            Active Stock Batches
          </span>
          <span className="text-xs text-gray-400 font-medium">
            Supplied by:{" "}
            {record?.suppliers && record?.suppliers.length > 0
              ? record?.suppliers?.map((s) => s.name).join(", ")
              : "No suppliers linked"}
          </span>
        </div>
        <Table
          dataSource={record.stocks}
          columns={stockBatchColumns}
          rowKey="id"
          pagination={false}
          size="small"
          bordered
          scroll={{ x: 500 }}
        />
      </div>
    </div>
  );
};
